<template>
  <div row :class="ui.colorNavigationBar">
    <v-layout row class="mr-3">
      <v-spacer/>
      <v-btn icon small :color="ui.bkgdColor" dark :to="'/userdash'"
      v-if="this.getUser.basic.act === true && this.getUser.basic.title !== ''">
        <v-badge right>
          <v-icon :color="ui.btnColor">{{userIcon}}</v-icon>
          <span :class="ui.textSubheadingBold" v-show="false"> 0 </span>
        </v-badge>
      </v-btn>
      <v-btn icon small :color="ui.bkgdColor" :disabled="true" v-else>
        <v-icon :color="ui.btnDisabledColor">{{userIcon}}</v-icon>
      </v-btn>

      <div v-if="this.getUser.pref.select.cauth !== null && this.cuserOK && this.userOK && this.getCompany !== null">
        <v-btn icon small :color="ui.bkgdColor" dark @click="goToCompanyDash()">
          <v-badge right>
            <v-icon :color="ui.btnColor">account_balance</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.cauth !== null">
              {{this.getUser.pref.select.cauth}}
            </span>
          </v-badge>
        </v-btn>
      </div>
      <div v-else-if="this.getUser.pref.select.cauth !== null && this.cuserOK && this.userOK">
        <v-btn icon small :color="ui.bkgdColor" dark @click="goToCompanyDash()">
          <v-badge right>
            <v-icon :color="ui.btnDisabledColor">account_balance</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.cauth !== null">
              {{this.getUser.pref.select.cauth}}
            </span>
          </v-badge>
        </v-btn>
      </div>
      <div v-else>
        <v-btn icon small :color="ui.bkgdColor" :disabled="true">
          <v-badge right>
            <v-icon :color="ui.btnDisabledColor">account_balance</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.cauth !== null">
              {{this.getUser.pref.select.cauth}}
            </span>
          </v-badge>
        </v-btn>
      </div>

      <!-- {{getFacilityAccess}} -->

      <div v-if="this.getUser.pref.select.fauth !== null && this.fuserOK && this.userOK && this.getFacility !== null">
        <v-btn icon small :color="ui.bkgdColor" dark @click="goToFacilityDash()">
          <v-badge right>
            <v-icon :color="ui.btnColor">place</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.fauth !== null">
            {{this.getUser.pref.select.fauth}}
          </span>
          </v-badge>
        </v-btn>
      </div>
      <div v-else-if="this.getUser.pref.select.fauth !== null && this.fuserOK && this.userOK">
        <v-btn icon small :color="ui.bkgdColor" dark @click="goToFacilityDash()">
          <v-badge right>
            <v-icon :color="ui.btnDisabledColor">place</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.fauth !== null">
            {{this.getUser.pref.select.fauth}}
          </span>
          </v-badge>
        </v-btn>
      </div>
      <div v-else>
        <v-btn icon small :color="ui.bkgdColor" :disabled="true">
          <v-badge right>
            <v-icon :color="ui.btnDisabledColor">place</v-icon>
            <span :class="ui.textSubheadingBold"
            v-if="this.getUser.pref.select.fauth !== null">
              {{this.getUser.pref.select.fauth}}
            </span>
          </v-badge>
        </v-btn>
      </div>


      <div v-if="this.auserOK">
        <v-btn icon small :color="ui.bkgdColor" dark @click="goToAssetDash()">
          <v-icon :color="ui.btnColor">emoji_transportation</v-icon>
        </v-btn>
      </div>
      <div v-else>
        <v-btn icon small :color="ui.bkgdColor" :disabled="true">
          <v-icon :color="ui.btnDisabledColor">emoji_transportation</v-icon>
        </v-btn>
      </div>

    </v-layout>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import pageAccess from "@/frame/control/mixins/pageAccess.js";
export default {
  mixins: [apptheme, adminFunctions, pageAccess],
  computed: {
    ...mapGetters([
      "getCompanyAccess",
      "getFacilityAccess",
      "getUser",
      "getCompany",
      "getFacility",
      "getAsset",
      "getDetail"
    ]),
    userIcon() {
      let icon = null;
      if (this.getUser.basic.admin === true) {
        icon = "manage_accounts";
      } else {
        icon = "person";
      }
      return icon;
    },
    cuserOK() {
      let logic = false;
      let access = this.getCompanyAccess;
      if (access !== null && this.getUser.pref.select.cauth !== null) {
        access = 9;
        // access = parseInt(this.getCompanyAccess);
        if (this.getUser.pref.select.cauth < access) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    fuserOK() {
      let logic = false;
      let access = this.getFacilityAccess;
      if (access !== null && this.getUser.pref.select.fauth !== null) {
        access = 9;
        // access = parseInt(this.getFacilityAccess);
        if (this.getUser.pref.select.fauth < access) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    auserOK() {
      let logic = false;
      if (this.getDetail !== null && this.getDetail.basic.tag === "A1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  }
};
</script>
